/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SessionIpEnrichment
 */
export interface SessionIpEnrichment {
    /**
     * 
     * @type {string}
     * @memberof SessionIpEnrichment
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionIpEnrichment
     */
    region?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionIpEnrichment
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionIpEnrichment
     */
    asn?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionIpEnrichment
     */
    asnOrganization?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SessionIpEnrichment
     */
    isVpn?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SessionIpEnrichment
     */
    isProxy?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SessionIpEnrichment
     */
    isTor?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SessionIpEnrichment
     */
    isHostingProvider?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SessionIpEnrichment
     */
    provider?: string;
    /**
     * 
     * @type {number}
     * @memberof SessionIpEnrichment
     */
    enrichedAt?: number;
}

/**
 * Check if a given object implements the SessionIpEnrichment interface.
 */
export function instanceOfSessionIpEnrichment(value: object): value is SessionIpEnrichment {
    return true;
}

export function SessionIpEnrichmentFromJSON(json: any): SessionIpEnrichment {
    return SessionIpEnrichmentFromJSONTyped(json, false);
}

export function SessionIpEnrichmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): SessionIpEnrichment {
    if (json == null) {
        return json;
    }
    return {
        
        'country': json['country'] == null ? undefined : json['country'],
        'region': json['region'] == null ? undefined : json['region'],
        'city': json['city'] == null ? undefined : json['city'],
        'asn': json['asn'] == null ? undefined : json['asn'],
        'asnOrganization': json['asnOrganization'] == null ? undefined : json['asnOrganization'],
        'isVpn': json['isVpn'] == null ? undefined : json['isVpn'],
        'isProxy': json['isProxy'] == null ? undefined : json['isProxy'],
        'isTor': json['isTor'] == null ? undefined : json['isTor'],
        'isHostingProvider': json['isHostingProvider'] == null ? undefined : json['isHostingProvider'],
        'provider': json['provider'] == null ? undefined : json['provider'],
        'enrichedAt': json['enrichedAt'] == null ? undefined : json['enrichedAt'],
    };
}

export function SessionIpEnrichmentToJSON(json: any): SessionIpEnrichment {
    return SessionIpEnrichmentToJSONTyped(json, false);
}

export function SessionIpEnrichmentToJSONTyped(value?: SessionIpEnrichment | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'country': value['country'],
        'region': value['region'],
        'city': value['city'],
        'asn': value['asn'],
        'asnOrganization': value['asnOrganization'],
        'isVpn': value['isVpn'],
        'isProxy': value['isProxy'],
        'isTor': value['isTor'],
        'isHostingProvider': value['isHostingProvider'],
        'provider': value['provider'],
        'enrichedAt': value['enrichedAt'],
    };
}

